//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        tags: {
            type: Array
        },
        average: Boolean,
        show_icon:Boolean
    },
    data() {
        return {
            index: 0
        }
    },
    methods: {
        changeTag (e) {
            const { value, id } = e.target.dataset
            this.index = id
            let selected = value
            this.$emit('change', selected)
        }
    }
}
